import {
    Alert,
    AlertIcon,
    Box,
    Heading,
    Spinner,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
    VStack,
    useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import UserManagementTab from "./UserManagementTab";
import AccessLogsTab from "./AccessLogsTab";
import AccessReportTab from "./AccessReportTab";

const UsersPage = () => {
    const [currentUserRole, setCurrentUserRole] = useState(null);
    const [loadingRole, setLoadingRole] = useState(true);
    const toast = useToast();

    useEffect(() => {
        const fetchCurrentUser = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await fetch("/api/users/me", {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (!response.ok) throw new Error("Erro ao buscar usuário atual");

                const data = await response.json();
                setCurrentUserRole(data.role || 0);
            } catch (error) {
                console.error("Erro ao carregar contexto de usuário:", error);
                toast({
                    title: "Erro ao carregar permissões da tela",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
                setCurrentUserRole(0);
            } finally {
                setLoadingRole(false);
            }
        };

        fetchCurrentUser();
    }, [toast]);

    if (loadingRole) {
        return (
            <Box p={6} flex="1" minH="100vh" bg="gray.100">
                <VStack py={16} spacing={3}>
                    <Spinner size="xl" color="teal.500" />
                    <Text color="gray.500">Carregando módulo de usuários...</Text>
                </VStack>
            </Box>
        );
    }

    if (currentUserRole < 4) {
        return (
            <Box p={6} flex="1" minH="100vh" bg="gray.100">
                <Heading mb={6}>Usuários</Heading>
                <Alert status="warning" borderRadius="md" bg="white">
                    <AlertIcon />
                    Você não tem permissão para acessar este módulo.
                </Alert>
            </Box>
        );
    }

    const tabs = [];

    if (currentUserRole >= 5) {
        tabs.push({
            key: "management",
            label: "Gestão de usuários",
            content: <UserManagementTab />,
        });
    }

    tabs.push({
        key: "access-logs",
        label: "Logs de acesso",
        content: <AccessLogsTab />,
    });

    tabs.push({
        key: "access-report",
        label: "Relatório de acesso",
        content: <AccessReportTab />,
    });

    return (
        <Box p={6} flex="1" minH="100vh" bg="gray.100">
            <Heading mb={6}>Usuários</Heading>

            <Tabs colorScheme="teal" variant="enclosed" isLazy>
                <TabList
                    bg="gray.100"
                    borderTopRadius="md"
                    borderBottomWidth="1px"
                    borderColor="gray.200"
                    px={2}
                    pt={2}
                >
                    {tabs.map((tab) => (
                        <Tab
                            key={tab.key}
                            fontWeight="semibold"
                            color="gray.700"
                            bg="gray.100"
                            borderTopRadius="md"
                            _selected={{
                                bg: "gray.50",
                                color: "teal.600",
                                borderColor: "gray.200",
                                borderBottomColor: "gray.50",
                            }}
                            _hover={{ color: "teal.600" }}
                        >
                            {tab.label}
                        </Tab>
                    ))}
                </TabList>

                <TabPanels bg="gray.50" borderBottomRadius="md" px={4} pb={4}>
                    {tabs.map((tab) => (
                        <TabPanel key={tab.key} px={0} pt={4}>
                            {tab.content}
                        </TabPanel>
                    ))}
                </TabPanels>
            </Tabs>
        </Box>
    );
};

export default UsersPage;